import WhsManagementGridActions from 'components/WhsManagement/whsManagementGridActions.js';
import whsManagementColumnDefs from 'components/WhsManagement/whsManagementColumnDefs.js';
import {
  GET_WHS_REQUEST, GET_WHS_SUCCESS, GET_WHS_FAILURE, NEW_WHS_GRID_CRITERIA
} from 'actions';

const initialState = {
  loading: true,
  data: [],
  error: '',
  actions: WhsManagementGridActions,
  gridCriteria: {
    columnDefs: whsManagementColumnDefs(),
    pageIndex: 0,
    sortBy: [],
    filters: [],
    pageCount: 0,
    pageSize: 10,
    itemCount: 0,
    selectedItems: [],
    selectedItem: null,
    activeTab: 0,
    totalLimit: 50000
  }
};

// eslint-disable-next-line default-param-last
function withholdingStatement(state = initialState, action) {
  switch (action.type) {
    case NEW_WHS_GRID_CRITERIA:
      return {
        ...state,
        gridCriteria: action.gridCriteria
      };
    case GET_WHS_REQUEST:
      return {
        ...state,
        loading: action.loading
      };
    case GET_WHS_SUCCESS:
      return {
        ...state,
        loading: action.loading,
        data: action.data.results,
        error: action.error,
        gridCriteria: {
          ...state.gridCriteria,
          itemCount: action.data.totalCount,
          pageCount: Math.ceil(action.data.totalCount / state.gridCriteria.pageSize)
        }
      };
    case GET_WHS_FAILURE:
      return {
        ...state,
        loading: action.loading,
        data: [],
        error: action.error
      };
    default:
      return state;
  }
}

export default withholdingStatement;
